const preProcessOptions = (options, parentLabel = '', parentValue = '') => {
  if (!Array.isArray(options)) return [];

  return options.map(option => {
    const fullLabel = parentLabel ? `${parentLabel} > ${option.label}` : option.label;
    const fullValue = option.value || option.filter_query;
    const value = option.value || option.filter_query;

    const processedOption = {
      ...option,
      fullLabel,
      fullValue,
      value
    };

    if (option.children && Array.isArray(option.children) && option.children.length > 0) {
      processedOption.children = preProcessOptions(option.children, fullLabel, fullValue);
    }

    return processedOption;
  });
};

export default preProcessOptions;
